<template lang="html">
    <div class="d-flex flex-fill">
        <div class="container py-3">
            <div class="row justify-content-center h-100">
                <div class="col-sm-12">
                    <div class="d-flex flex-column w-100 h-100">
                        <div class="flex-grow-1">
                            <h3 class="mb-2 bold fs-normal d-flex justify-content-between">
                                <span>Billing Details</span>
                            </h3>
                            <tab-billing-details v-if="reservation" :reservation="reservation" :readOnly="isReservationReadOnly && reservation.status != -5 || getIsSavingReservation" :showInvoiceBtn="false"></tab-billing-details>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import TabBillingDetails from '@/components/reservations/NewReservation/Resume/Details/BillingDetails'
import { mapGetters } from 'vuex'

export default {
    props: {
        reservation: {
            type: Object,
            required: true
        }
    },
    computed:{
        ...mapGetters([
            'getIsSavingReservation',
        ]),
    },
    mixins: [
        reservationsMixin
    ],
    components: {
        TabBillingDetails,
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TabBilling.vue?3c39841f